import { apiFetch } from "./client";

async function parseError(response) {
    try {
        const json = await response.json();

        return (
            json.error ||
            json.errors?.join(", ") ||
            `Request failed with status ${response.status}`
        );
    } catch {
        return `Request failed with status ${response.status}`;
    }
}

function normalizeMontlyReport(report) {
    return {
        year: report.year,
        month: report.month,
        totalAmount: report.total_amount,
        expenses: report.expenses.map((expense) => ({
            id: expense.id,
            expenseId: expense.expense_id,
            expenseTitle: expense.expense_title,
            amount: expense.amount,
        })),
    };
}

export async function fetchMontlyReports() {
    const response = await apiFetch("/api/montly_reports");

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return json.montly_reports.map(normalizeMontlyReport);
}

export async function createMontlyReport({ reportIds }) {
    const response = await apiFetch("/api/montly_reports", {
        method: "POST",
        body: JSON.stringify({
            montly_report: {
                report_ids: reportIds,
            },
        }),
    });

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return json.montly_reports.map(normalizeMontlyReport);
}
